/**
 * PercentBar - Progress bar visualization for permit usage
 */

import React from "react";
import { getPercentStatus, formatPercent } from "../../utils";
import {
  StyledTableCell,
  PercentBarContainer,
  StyledLinearProgress,
  PercentValue,
} from "../styled";

/**
 * Percent bar cell component
 * @param {Object} props
 * @param {number} props.value - Percentage as decimal (0-1+)
 */
const PercentBar = React.memo(({ value }) => {
  const pct = Number(value) || 0;
  const status = getPercentStatus(pct);
  const displayPct = Math.min(pct * 100, 100);

  return (
    <StyledTableCell align="right">
      <PercentBarContainer>
        <StyledLinearProgress
          variant="determinate"
          value={displayPct}
          $status={status}
        />
        <PercentValue>{formatPercent(pct)}</PercentValue>
      </PercentBarContainer>
    </StyledTableCell>
  );
});

PercentBar.displayName = "PercentBar";

export default PercentBar;
